import { Licence } from './../../supplier/models/Licence';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { Supplier } from '../../supplier/models/Supplier';
import { AnreService } from '../service/anre.service';
import { RequestStatusFui } from '../../supplier/models/RequestStatusFui';
import { Page } from '../../../shared/model/page';
import { SupplierFilterForm } from '../notifications-anre/models/SupplierFilterForm';

type Pagination = {
  pageNumber: number;
  className: string;
}

@Component({
  selector: 'app-suppliers-anre',
  templateUrl: './suppliers-anre.component.html',
  styleUrls: ['./suppliers-anre.component.scss']
})
export class SuppliersAnreComponent implements OnInit {

  public electricSuppliers: Page<Supplier>;
  public paginationElectricSuppliers: Pagination[];
  public electricSuppliersFilterForm: SupplierFilterForm = new SupplierFilterForm();
  public gasSuppliers: Page<Supplier>;
  public paginationGasSuppliers: Pagination[];
  public gasSuppliersFilterForm: SupplierFilterForm = new SupplierFilterForm();
  public tabSelected: string;
  public electricSuppliersDisplaySettings = {
    actions: {
      custom: [
        {
          name: 'view',
          title: '<p class="action_VD">Vezi detalii</p>'
        },
        ////////// -----------------------------------
        {
          name: 'activateFui',
          title: '<p class="action_fui_nd"><b>FUI:</b> Nominalizează/Desemnează</p>'
        },
        {
          name: 'nominalizeazaFui',
          title: '<p class="action_fui_n"><b>FUI:</b> Nominalizează</p>'
        },
        {
          name: 'inactiveazaFui',
          title: '<p class="action_fui_i"><b>FUI:</b> Inactivează</p>'
        },
        {
          name: 'cancelRequest',
          title: '<p class="action_fui_c"><b>FUI:</b> Anulează Cerere</p>'
        },
        ////////// -----------------------------------
        {
          name: 'srActiv', // pentru ACTIV
          title: '<p class="action_SRL"><b>Licenţă:</b> Suspendă/Retrage</p>'
        },
        {
          name: 'sSuspend', // pentru Suspendate
          title: '<p class="action_RL"><b>Licenţă:</b> Retrage</p>'
        },
        {
          name: 'editeazaLicenta', // PENDING
          title: '<p class="action_SRLE"><b>Licenţă:</b> Editeaza in curs de schimbare</p>'
        },
        {
          name: 'suspendRSL',
          title: '<p class="action_RS"><b>Licenţă:</b> Ridică suspendare</p>'
        },
        {
          name: 'cancelRSL',
          title: '<p class="action_ARS"><b>Licenţă:</b> Revocă ridicare suspendare</p>'
        },
        {
          name: 'cancelRL',
          title: '<p class="action_AA"><b>Licenţă:</b> Revocă retragere</p>'
        },
        {
          name: 'cancelSL',
          title: '<p class="action_AS"><b>Licenţă:</b> Revocă suspendare</p>'
        },
        {
          name: 'modifyIntegration',
          title: '<p>Modifică integrarea</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row: any) => {
      let _class = '';
      if (row.data.statusElectricity === 'ACTIVE') {
        _class = 'row_ACTIVE ';
      } else if (row.data.statusElectricity === 'SUSPENDED') {
        _class = 'row_SUSPENDED ';
      } else if (row.data.statusElectricity === 'WITHDRAWN') {
        _class = 'row_WITHDRAWN ';
      } else if (row.data.statusElectricity === 'ACTIVE_PENDING') {
        _class = 'row_ACTIVE_PENDING ';
      } else if (row.data.statusElectricity === 'SUSPENDED_PENDING') {
        _class = 'row_SUSPENDED_PENDING ';
      } else if (row.data.statusElectricity === 'WITHDRAWN_PENDING') {
        _class = 'row_WITHDRAWN_PENDING ';
      } else {
        _class = '';
      }
      if (!row.data.fuiTypeElectricity) {
        _class += 'row_fui_INACTIVE';
      } else if (row.data.fuiTypeElectricity === 'DESEMNAT') {
        _class += 'row_fui_DESEMNAT';
      } else if (row.data.fuiTypeElectricity === 'NOMINALIZAT') {
        _class += 'row_fui_NOMINALIZAT';
      } else if (row.data.fuiTypeElectricity === 'DESEMNAT_PENDING') {
        _class += 'row_fui_DESEMNAT_PENDING';
      } else if (row.data.fuiTypeElectricity === 'NOMINALIZAT_PENDING') {
        _class += 'row_fui_NOMINALIZAT_PENDING';
      } else if (row.data.fuiTypeElectricity === 'INACTIVE_PENDING') {
        _class += 'row_fui_INACTIVE_PENDING';
      }
      return _class;

    },
    hideSubHeader: true,
    columns: {
      code: {
        title: 'CUI'
      },
      name: {
        title: 'Furnizor'
      },
      fuiElectricityDecisionNumber: {
        title: 'Număr Decizie'
      },
      fuiTypeElectricityValue: {
        title: 'Status FUI'
      },
      statusElectricityValue: {
        title: 'Status licenţă',
        valuePrepareFunction: (statusElectricityValue: any) => {
          return statusElectricityValue;
        }
      },
      electricitySeries: {
        title: 'Licenţă Electricitate'
      },
      gasSeries: {
        title: 'Licenţă gaz'
      },
      associationStatus: {
        title: 'Status'
      },
      integrated: {
        title: 'Status integrare',
        valuePrepareFunction: (integrated: any) => {
          return integrated ? 'Integrat' : 'Neintegrat';
        }
      }
    },
    pager: {
      display: false
    }
  };
  public gasSuppliersDisplaySettings = {
    actions: {
      custom: [
        {
          name: 'view',
          title: '<p class="action_VD">Vezi detalii</p>'
        },
        ////////// -----------------------------------
        {
          name: 'activateFui',
          title: '<p class="action_fui_nd"><b>FUI:</b> Nominalizează/Desemnează</p>'
        },
        {
          name: 'nominalizeazaFui',
          title: '<p class="action_fui_n"><b>FUI:</b> Nominalizează</p>'
        },
        {
          name: 'inactiveazaFui',
          title: '<p class="action_fui_i"><b>FUI:</b> Inactivează</p>'
        },
        {
          name: 'cancelRequest',
          title: '<p class="action_fui_c"><b>FUI:</b> Anulează Cerere</p>'
        },
        ////////// -----------------------------------
        {
          name: 'srActiv', // pentru ACTIV
          title: '<p class="action_SRL"><b>Licenţă:</b> Suspendă/Retrage</p>'
        },
        {
          name: 'sSuspend', // pentru Suspendate
          title: '<p class="action_RL"><b>Licenţă:</b> Retrage</p>'
        },
        {
          name: 'editeazaLicenta', // PENDING
          title: '<p class="action_SRLE"><b>Licenţă:</b> Editeaza in curs de schimbare</p>'
        },
        {
          name: 'suspendRSL',
          title: '<p class="action_RS"><b>Licenţă:</b> Ridică suspendare</p>'
        },
        {
          name: 'cancelRSL',
          title: '<p class="action_ARS"><b>Licenţă:</b> Revocă ridicare suspendare</p>'
        },
        {
          name: 'cancelRL',
          title: '<p class="action_AA"><b>Licenţă:</b> Revocă retragere</p>'
        },
        {
          name: 'cancelSL',
          title: '<p class="action_AS"><b>Licenţă:</b> Revocă suspendare</p>'
        },
        {
          name: 'modifyIntegration',
          title: '<p>Modifică integrarea</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row: any) => {
      let _class = '';
      if (row.data.statusGas === 'ACTIVE') {
        _class = 'row_ACTIVE ';
      } else if (row.data.statusGas === 'SUSPENDED') {
        _class = 'row_SUSPENDED ';
      } else if (row.data.statusGas === 'WITHDRAWN') {
        _class = 'row_WITHDRAWN ';
      } else if (row.data.statusGas === 'ACTIVE_PENDING') {
        _class = 'row_ACTIVE_PENDING ';
      } else if (row.data.statusGas === 'SUSPENDED_PENDING') {
        _class = 'row_SUSPENDED_PENDING ';
      } else if (row.data.statusGas === 'WITHDRAWN_PENDING') {
        _class = 'row_WITHDRAWN_PENDING ';
      } else {
        _class = '';
      }
      if (!row.data.fuiTypeGas) {
        _class += 'row_fui_INACTIVE';
      } else if (row.data.fuiTypeGas === 'DESEMNAT') {
        _class += 'row_fui_DESEMNAT';
      } else if (row.data.fuiTypeGas === 'NOMINALIZAT') {
        _class += 'row_fui_NOMINALIZAT';
      } else if (row.data.fuiTypeGas === 'DESEMNAT_PENDING') {
        _class += 'row_fui_DESEMNAT_PENDING';
      } else if (row.data.fuiTypeGas === 'NOMINALIZAT_PENDING') {
        _class += 'row_fui_NOMINALIZAT_PENDING';
      } else if (row.data.fuiTypeGas === 'INACTIVE_PENDING') {
        _class += 'row_fui_INACTIVE_PENDING';
      }
      return _class;
    },
    hideSubHeader: true,
    columns: {
      code: {
        title: 'CUI'
      },
      name: {
        title: 'Furnizor'
      },
      fuiGasDecisionNumber: {
        title: 'Număr Decizie'
      },
      fuiTypeGasValue: {
        title: 'Status FUI'
      },
      statusGasValue: {
        title: 'Status licenţă',
        valuePrepareFunction: (statusGasValue: any) => {
          return statusGasValue;
        }
      },
      electricitySeries: {
        title: 'Licenţă Electricitate'
      },
      gasSeries: {
        title: 'Licenţă gaz'
      },
      associationStatus: {
        title: 'Status'
      },
      integrated: {
        title: 'Status integrare',
        valuePrepareFunction: (integrated: any) => {
          return integrated ? 'Integrat' : 'Neintegrat';
        }
      }
    },
    pager: {
      display: false
    }
  };

  @ViewChild(NgbTabset, { static: false }) tabset: NgbTabset;

  constructor(
    private anreService: AnreService,
    private router: Router
  ) {
    if (!!JSON.parse(localStorage.getItem('isGas'))) {
      this.tabSelected = 'gas';
    }
  }

  ngOnInit(): void {
    this.searchAnreElectricSuppliers();
    this.searchAnreGasSuppliers();
  }

  searchAnreElectricSuppliers(pageOffset?: number): void {
    this.electricSuppliersFilterForm.pageOffset = pageOffset != null ? pageOffset : this.electricSuppliersFilterForm.pageOffset;
    this.anreService.getAnreElectricSuppliers(this.electricSuppliersFilterForm).subscribe((suppliers: Page<Supplier>) => {
      this.electricSuppliers = suppliers;
      this.electricSuppliersFilterForm.pageOffset = suppliers.number;
      this.paginationElectricSuppliers = [{ pageNumber: suppliers.number, className: 'page-item active' }];
    });
  }

  searchAnreGasSuppliers(pageOffset?: number): void {
    this.gasSuppliersFilterForm.pageOffset = pageOffset != null ? pageOffset : this.gasSuppliersFilterForm.pageOffset;
    this.anreService.getAnreGasSuppliers(this.gasSuppliersFilterForm).subscribe((suppliers: Page<Supplier>) => {
      this.gasSuppliers = suppliers;
      this.gasSuppliersFilterForm.pageOffset = suppliers.number;
      this.paginationGasSuppliers = [{ pageNumber: suppliers.number, className: 'page-item active' }];
    });
  }

  onCustomActionElectricSuppliers(event: any): void {
    localStorage.removeItem('isGas');
    switch (event.action) {
      case 'inactiveazaFui': {
        localStorage.setItem('actionType', 'inactiveazaFui');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        this.router.navigateByUrl('/anre/furnizor-fui');
        break;
      }
      case 'nominalizeazaFui': {
        localStorage.setItem('actionType', 'nominalizeazaFui');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        this.router.navigateByUrl('/anre/furnizor-fui');
        break;
      }
      case 'activateFui': {
        localStorage.setItem('actionType', 'activateFui');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        this.router.navigateByUrl('/anre/furnizor-fui');
        break;
      }
      case 'suspendRSL': {
        localStorage.setItem('actionType', 'ridicaSuspendare');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        localStorage.setItem('licence', JSON.stringify(event.data.electricityLicence));
        this.router.navigateByUrl('/anre/licenta-furnizor');
        break;
      }
      case 'view': {
        localStorage.setItem('supplierId', event.data.id);
        this.router.navigateByUrl('/anre/furnizor-detalii');
        break;
      }
      case 'editeazaLicenta': {
        localStorage.setItem('actionType', 'editeazaLicenta');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        localStorage.setItem('licence', JSON.stringify(event.data.electricityLicence));
        this.router.navigateByUrl('/anre/licenta-furnizor');
        break;
      }
      case 'srActiv': {
        localStorage.setItem('actionType', 'retrageSuspendaLicenta');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        localStorage.setItem('licence', JSON.stringify(event.data.electricityLicence));
        this.router.navigateByUrl('/anre/licenta-furnizor');
        break;
      }
      case 'sSuspend': {
        localStorage.setItem('actionType', 'retrageLicenta');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        localStorage.setItem('licence', JSON.stringify(event.data.electricityLicence));
        this.router.navigateByUrl('/anre/licenta-furnizor');
        break;
      }
      case 'cancelRSL': {
        this.revocaLicente('Licenta: Revoca ridicare suspendare', event.data.name, event.data.electricityLicence);
        break;
      }
      case 'cancelRL': {
        this.revocaLicente('Licenta: Revoca retragere', event.data.name, event.data.electricityLicence);
        break;
      }
      case 'cancelSL': {
        this.revocaLicente('Licenta: Revoca suspendare', event.data.name, event.data.electricityLicence);
        break;
      }
      case 'cancelRequest': {
        let action: string;
        switch (event.data.fuiTypeElectricity) {
          case 'INACTIVE_PENDING':
            action = 'inactivare';
            break;
          case 'DESEMNAT_PENDING':
            action = 'desemnare';
            break;
          case 'NOMINALIZAT_PENDING':
            action = 'nominalizare';
            break;
        }
        this.revocaFui('FUI: Revoca in curs de ' + action, event.data.name, event.data.fuiElectricity);
        break;
      }
      case 'modifyIntegration': {
        event.data.integrated = !event.data.integrated;
        this.anreService.modifySupplierIntegration(event.data).subscribe(() => this.ngOnInit());
        break;
      }
    }
  }

  revocaLicente(action: string, supplierName: string, licence: Licence): void {
    Swal.fire({
      html: `A fost selectata optiunea <b>${action}</b> pentru furnizorul <b>${supplierName}</b>`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Renunta',
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    }).then(result => {
      if (result.value) {
        this.anreService.cancelLicenceStatus(licence).subscribe(() => {
          this.search();
        });
      }
    });
  }

  revocaFui(action: string, supplierName: string, requestStatusFui: RequestStatusFui): void {
    Swal.fire({
      html: `A fost selectata optiunea <b>${action}</b> pentru furnizorul <b>${supplierName}</b>`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Renunta',
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    }).then(result => {
      if (result.value) {
        this.anreService.cancelRequestStatusFui(requestStatusFui).subscribe(() => {
          this.search();
        });
      }
    });
  }

  onCustomActionGasSuppliers(event: any): void {
    console.log(event.action);
    localStorage.setItem('isGas', 'true');
    switch (event.action) {
      case 'inactiveazaFui': {
        localStorage.setItem('actionType', 'inactiveazaFui');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        this.router.navigateByUrl('/anre/furnizor-fui');
        break;
      }
      case 'nominalizeazaFui': {
        localStorage.setItem('actionType', 'nominalizeazaFui');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        this.router.navigateByUrl('/anre/furnizor-fui');
        break;
      }
      case 'activateFui': {
        localStorage.setItem('actionType', 'activateFui');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        this.router.navigateByUrl('/anre/furnizor-fui');
        break;
      }
      case 'suspendRSL': {
        localStorage.setItem('actionType', 'ridicaSuspendare');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        localStorage.setItem('licence', JSON.stringify(event.data.gasLicence));
        this.router.navigateByUrl('/anre/licenta-furnizor');
        break;
      }
      case 'view': {
        localStorage.setItem('supplierId', event.data.id);
        this.router.navigateByUrl('/anre/furnizor-detalii');
        break;
      }
      case 'editeazaLicenta': {
        localStorage.setItem('actionType', 'editeazaLicenta');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        localStorage.setItem('licence', JSON.stringify(event.data.gasLicence));
        this.router.navigateByUrl('/anre/licenta-furnizor');
        break;
      }
      case 'srActiv': {
        localStorage.setItem('actionType', 'retrageSuspendaLicenta');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        localStorage.setItem('licence', JSON.stringify(event.data.gasLicence));
        this.router.navigateByUrl('/anre/licenta-furnizor');
        break;
      }
      case 'sSuspend': {
        localStorage.setItem('actionType', 'retrageLicenta');
        localStorage.setItem('supplier', JSON.stringify(event.data));
        localStorage.setItem('licence', JSON.stringify(event.data.gasLicence));
        this.router.navigateByUrl('/anre/licenta-furnizor');
        break;
      }
      case 'cancelRSL': {
        this.revocaLicente('Licenţă: Revocă ridicare suspendare', event.data.name, event.data.gasLicence);
        break;
      }
      case 'cancelRL': {
        this.revocaLicente('Licenţă: Revocă retragere', event.data.name, event.data.gasLicence);
        break;
      }
      case 'cancelSL': {
        this.revocaLicente('Licenţă: Revocă suspendare', event.data.name, event.data.gasLicence);
        break;
      }
      case 'cancelRequest': {
        let action: string;
        switch (event.data.fuiTypeGas) {
          case 'INACTIVE_PENDING':
            action = 'inactivare';
            break;
          case 'DESEMNAT_PENDING':
            action = 'desemnare';
            break;
          case 'NOMINALIZAT_PENDING':
            action = 'nominalizare';
            break;
        }
        this.revocaFui('FUI: Revoca in curs de ' + action, event.data.name, event.data.fuiGas);
        break;
      }
      case 'modifyIntegration': {
        event.data.integrated = !event.data.integrated;
        this.anreService.modifySupplierIntegration(event.data).subscribe(() => this.ngOnInit());
        break;
      }
    }
  }

  changePage(page: Pagination): void {
    if (this.tabset.activeId == "electricity") {
      this.electricSuppliersFilterForm.pageOffset = page.pageNumber;
      this.searchAnreElectricSuppliers();
    }
    else {
      this.gasSuppliersFilterForm.pageOffset = page.pageNumber;
      this.searchAnreGasSuppliers();
    }
  }

  previousPage(): void {
    if (this.tabset.activeId == "electricity") {
      this.electricSuppliersFilterForm.pageOffset = this.electricSuppliersFilterForm.pageOffset === 0 ? 0 : this.electricSuppliersFilterForm.pageOffset - 1;
      this.searchAnreElectricSuppliers();
    }
    else if (this.tabset.activeId == "gas") {
      this.gasSuppliersFilterForm.pageOffset = this.gasSuppliersFilterForm.pageOffset === 0 ? 0 : this.gasSuppliersFilterForm.pageOffset - 1;
      this.searchAnreGasSuppliers();
    }
  }

  nextPage(): void {
    if (this.tabset.activeId == "electricity") {
      this.electricSuppliersFilterForm.pageOffset = this.electricSuppliersFilterForm.pageOffset === this.electricSuppliers.totalPages - 1
        ? this.electricSuppliersFilterForm.pageOffset : this.electricSuppliersFilterForm.pageOffset + 1;
      this.searchAnreElectricSuppliers();
    }
    else if (this.tabset.activeId == "gas") {
      this.gasSuppliersFilterForm.pageOffset = this.gasSuppliersFilterForm.pageOffset === this.gasSuppliers.totalPages - 1
        ? this.gasSuppliersFilterForm.pageOffset : this.gasSuppliersFilterForm.pageOffset + 1;
      this.searchAnreGasSuppliers();
    }
  }

  search(pageOffset?: number): void {
    if (this.tabset.activeId == 'electricity') {
      this.searchAnreElectricSuppliers(pageOffset);
    } else {
      this.searchAnreGasSuppliers(pageOffset);
    }
  }

  onTabChange(event: any): void {
    if (event.nextId === 'gas') {
      localStorage.setItem('isGas', 'true');
    } else {
      localStorage.removeItem('isGas');
    }
  }
}
